import { ArrowRight } from 'lucide-react';

// Final call-to-action band before the footer. Colors reference brand tokens (--brand-*).
export default function NrouteClosingCTA({ onRequestAccess }) {
  return (
    <section className="relative overflow-hidden py-24" style={{ backgroundColor: 'var(--brand-primary)' }}>
      <div
        className="pointer-events-none absolute left-1/2 top-0 h-64 w-64 -translate-x-1/2 rounded-full blur-[100px]"
        style={{ background: 'radial-gradient(circle, color-mix(in srgb, var(--brand-secondary) 25%, transparent), transparent 70%)' }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-3xl px-4 text-center">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-5xl">
          Find your north star.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg text-slate-300">
          Join the students charting a clearer route to studying abroad with nroute.
        </p>
        <div className="mt-9 flex justify-center">
          <button
            onClick={onRequestAccess}
            className="group inline-flex items-center justify-center gap-2 rounded-xl px-9 py-4 text-base font-semibold shadow-lg transition-all hover:brightness-105 hover:shadow-[0_0_32px_rgba(232,168,56,0.4)]"
            style={{ backgroundColor: 'var(--brand-secondary)', color: 'var(--brand-primary)' }}
          >
            Request access
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </section>
  );
}
